import type { ComponentType } from 'react';

let _ref: ComponentType<any> | null = null;

export function setControlRendererRef(c: ComponentType<any>): void {
  _ref = c;
}

export function getControlRendererRef(): ComponentType<any> {
  if (!_ref) throw new Error('ControlRenderer not registered — import ControlRenderer before using reactiveSlotBlock');
  return _ref;
}
